import { useStoreon } from 'storeon/react';

const useModal = () => {
  const { dispatch, showModal } = useStoreon('showModal');

  const openModal = (ModalName: any, props = {}) => {
    dispatch('modal/toggle', { modal: ModalName, props });
  };

  const closeModal = () => {
    dispatch('modal/toggle', { modal: 'empty' });
  };

  const openModalCall = (phone: string): void => {
    dispatch('modalCall/show', true);
    dispatch('modalCall/setInfo', {
      type: 'DEFAULT',
      phone: `+${phone}`,
    });
  };

  return { openModal, closeModal, openModalCall, showModal };
};

export default useModal;
